import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { yourSayAuthorAuthor$key } from "scmp-app/queries/__generated__/yourSayAuthorAuthor.graphql";

import { AuthorAvatarContainer, AuthorName, Container, StyledAuthorAvatar } from "./styles";
type Props = {
  className?: string;
  reference: yourSayAuthorAuthor$key;
};

export const YourSayAuthor: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const author = useFragment(
    graphql`
      fragment yourSayAuthorAuthor on Author {
        name

        ...authorAvatarAuthor
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      <AuthorAvatarContainer>
        <StyledAuthorAvatar height={160} placeholder={true} reference={author} width={160} />
      </AuthorAvatarContainer>
      <AuthorName>{author?.name}</AuthorName>
    </Container>
  );
};

YourSayAuthor.displayName = "YourSayAuthor";
